<template>
  <v-sheet height="100%" class="neu-glow-inset fluo">
    <v-container class="fill-height justify-center" fluid>
      <v-col cols="10" lg="9" xl="8">
        <v-sheet class="neu-glow with-radius" :class="$vuetify.breakpoint.smAndDown?'pa-1':'pa-5'">        
            <v-form @submit.prevent="$v.userForm.$invalid ? null : submit()" ref="userForm">
                <v-stepper v-model="e1" elevation="8" class="neu-glow-inset pa-4">
                    <v-stepper-header>
                        <v-stepper-step :complete="e1 > 1" step="1" color="info">
                            Inserimento Partita IVA
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="e1 > 2" step="2" color="info">
                            Verifica Account
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="e1 == 3" step="4" color="info">
                            Autenticazione Completata
                        </v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <v-card
                                class="mb-2"
                                color="lighten-1"
                            >
                                <v-row>
                                    <v-col cols="12" md="6" class="d-flex justify-center">
                                        <v-img lazy-src="https://ibookrestaurant.com/static/ob-animated-isometric/sign-up-animate.svg"  src="https://ibookrestaurant.com/static/ob-animated-isometric/sign-up-animate.svg"></v-img>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-card class="neu-glow elevation-4 mr-2 mt-4">
                                            <v-card-title>
                                                Benvenuti su <span class="font-weight-bold px-1"> iBookrestaurant </span>
                                            </v-card-title>
                                            <v-card-text>
                                                Piattaforma per la gestione delle attività di ristorazione riservata agli operatori con codice ATECO 56.xxx
                                            </v-card-text>
                                        </v-card>
                                        <v-card class="elevation-4 mr-2 mt-4">
                                            <v-card-title>
                                                Indica codice Agente
                                            </v-card-title>
                                            <v-card-text>
                                                <v-text-field
                                                @input="$v.userForm.agentId"
                                                @focus="userForm.agentId=null"
                                                prepend-inner-icon="mdi-account"
                                                name="agentId"
                                                ref="agentId"
                                                v-model="userForm.agentId"
                                                label="Codice Agente"
                                                outlined
                                                autocomplete="off"
                                                color="info"
                                                persistent-hint
                                                hint="Inserire SEMPRE un valore (altrimenti l'account non viene attivato)"
                                                />
                                            </v-card-text>
                                        </v-card>
                                        <v-card class="elevation-4 mt-4 mr-2">
                                            <v-card-text>
                                                <v-switch
                                                    v-model="userForm.allowDuplicateVATNumber"
                                                    inset
                                                    :false-value="-1"
                                                    :true-value="1"
                                                    label="Consenti Riutilizzo Partita IVA"
                                                ></v-switch>
                                            </v-card-text>
                                        </v-card>
                                        <v-card class="elevation-4 mt-4 mr-2">
                                            <v-card-title>
                                                Inserisci la Partita IVA
                                            </v-card-title>                                
                                            <v-card-text>
                                                <v-text-field
                                                :error-messages="fieldErrors('userForm.VATNumber').length>0?fieldErrors('userForm.VATNumber'):null"
                                                @input="$v.userForm.VATNumber.$touch()"
                                                @focus="userForm.VATNumber=null"
                                                prepend-inner-icon="mdi-id-card"
                                                name="VATNumber"
                                                :rules="VATRules"
                                                ref="VATNumber"
                                                v-model="userForm.VATNumber"
                                                label="Partita IVA"
                                                outlined
                                                autocomplete="off"
                                                color="info"
                                                counter="11"
                                                />
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-btn to="/auth/login" v-bind="attrs" fab class="neu-glow float-right mr-5" v-on="on" >
                                                <v-icon 
                                                large
                                                color="info"
                                                class="mx-3"
                                                >
                                                    mdi-close
                                                </v-icon>
                                            </v-btn>
                                            </template>
                                            <span>Esci</span>
                                        </v-tooltip>                                         
                                    </v-col>
                                </v-row>
                            </v-card>
                            <!--
                            <v-btn
                            color="primary"
                            @click="e1 = 2"
                            >
                                Continua
                            </v-btn>
                            <v-btn text>
                                Ricomincia
                            </v-btn>
                            -->
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <v-card
                                class="mb-2"
                                color="lighten-1"
                                v-if="VATResponse&&VATResponse.settings.pec!=''"
                            >
                                <v-row>
                                    <v-col cols="12" md="6" class="d-flex justify-center">
                                        <v-img lazy-src="https://ibookrestaurant.com/static/ob-animated-isometric/enter-otp-animate.svg"  src="https://ibookrestaurant.com/static/ob-animated-isometric/enter-otp-animate.svg"></v-img>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <!--
                                        <v-card class="neu-glow mr-2 mt-6">
                                            <v-card-title>
                                                Verifica Account
                                            </v-card-title>
                                            <v-card-text>
                                                ti abbiamo inviato una OTP sulla casella di posta <br>
                                                <div class="font-weight-bold mt-5 text-center text-h5">{{VATResponse.settings.dettaglio.pec}}</div>.
                                            </v-card-text>
                                        </v-card>
                                        -->
                                        <v-card class="neu-glow mr-2 mt-8">
                                            <v-card-title>
                                                Inserisci {{VATResponse.all.otpVAT}} qui sotto
                                            </v-card-title>
                                        <v-card-text>
                                        <v-card-text>
                                        <v-card-text>
                                            <v-text-field
                                            :error-messages="fieldErrors('userForm.OTP').length>0?fieldErrors('userForm.OTP'):null"
                                            @input="$v.userForm.OTP.$touch()"
                                            @focus="userForm.OTP=null"
                                            prepend-inner-icon="mdi-numeric"
                                            name="OTP"
                                            :rules="OTPRules"
                                            ref="OTP"
                                            v-model="userForm.OTP"
                                            label="OTP"
                                            placeholder="000-000-000"
                                            v-mask="'###-###-###'" 
                                            outlined
                                            autocomplete="off"
                                            color="info"
                                            counter="11"
                                            hint="Solo i Numeri"
                                            persistent-hint 
                                            :class="$vuetify.breakpoint.smAndDown?'text-h5':'text-h4'"
                                            />                                            
                                            <v-overlay absolute :value="loader">
                                            <v-progress-circular
                                                indeterminate
                                                color="info"
                                            ></v-progress-circular>
                                            </v-overlay>
                                        </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card>
                            <!--
                            <v-btn
                            color="primary"
                            @click="e1 = 2"
                            >
                                Continua
                            </v-btn>
                            <v-btn text>
                                Ricomincia
                            </v-btn>
                            -->
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <v-card
                                class="mb-2 neu-glow"
                                color="lighten-1"
                            >
                                <v-row>
                                    <v-col cols="12" md="6" class="d-flex justify-center">
                                        <v-img lazy-src="https://ibookrestaurant.com/static/ob-animated-isometric/completed-steps-animate.svg"  src="https://ibookrestaurant.com/static/ob-animated-isometric/completed-steps-animate.svg"></v-img>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-card class="neu-glow mr-2 mt-6">
                                        <v-card-title>
                                            Autenticazione Completata!
                                        </v-card-title>
                                        <v-card-text>
                                            Ora puoi configurare il tuo account:
                                            <ul>
                                                <li>Definire Aree, Sale e Orari</li>
                                                <li>Inserire i Tavoli e le possibili combinazioni di utilizzo</li>
                                                <li>Impostare tutti i parametri per migliorare il servizio</li>
                                                <li>ed altro Ancora!</li>
                                            </ul>
                                        </v-card-text>
                                        <v-card-text class="text-right">
                                          <v-btn large @click="goTo()" color="info">Continua</v-btn>
                                        </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card>
                            <!--
                            <v-btn
                            color="primary"
                            @click="e1 = 2"
                            >
                                Continua
                            </v-btn>
                            <v-btn text>
                                Ricomincia
                            </v-btn>
                            -->
                        </v-stepper-content>
                        <v-stepper-content step="4">
                            <v-card
                                class="mb-2"
                                color="lighten-1"
                            >
                                <v-row>
                                    <v-col cols="12" md="6" class="d-flex justify-center">
                                        <v-img lazy-src="/static/ob-animated-isometric/computer-login-animate.svg"  src="/static/ob-animated-isometric/computer-login-animate.svg"></v-img>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-card class="neu-glow elevation-4 mr-2 mt-6">
                                        <v-card-title>
                                            Questa Partita IVA risulta già registrata sul sistema
                                        </v-card-title>
                                        <v-card-text class="text-right mr-3">
                                            <router-link
                                                to="/auth/login"
                                                class="py-1"
                                            >
                                              <v-btn large color="info">Login</v-btn>
                                            </router-link>
                                        </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card>
                         </v-stepper-content>
                        <v-stepper-content step="5">
                            <v-card
                                class="mb-2"
                                color="lighten-1"
                            >
                                <v-row>
                                    <v-col cols="12" md="6" class="d-flex justify-center">
                                        <v-img lazy-src="https://ibookrestaurant.com/static/ob-animated-isometric/enter-otp-animate.svg"  src="https://ibookrestaurant.com/static/ob-animated-isometric/enter-otp-animate.svg"></v-img>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-card class="neu-glow elevation-4 mr-2 mt-6">
                                        <v-card-title>
                                            Partita IVA Errata
                                        </v-card-title>
                                        <v-card-text>
                                            Non abbiamo trovato la Partita IVA {{userForm.VATNumber}}
                                        </v-card-text>
                                        <v-card-text>
                                            <v-btn @click="userForm.VATNumber='';userForm.OTP='';e1=1" color="info">Riprova</v-btn>

                                        </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card>
                         </v-stepper-content>
                        <v-stepper-content step="6">
                            <v-card
                                class="mb-2"
                                color="lighten-1"
                                v-if="VATResponse&&VATResponse.settings"
                            >
                                <v-row>
                                    <v-col cols="12" md="6" class="d-flex justify-center">
                                        <v-img lazy-src="https://ibookrestaurant.com/static/ob-animated-isometric/enter-otp-animate.svg"  src="https://ibookrestaurant.com/static/ob-animated-isometric/enter-otp-animate.svg"></v-img>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-card class="neu-glow elevation-4 mr-2 mt-6">
                                        <v-card-title>
                                            Codice ATECO non valido
                                        </v-card-title>
                                        <v-card-text>
                                            Il registro imprese ci comunuca che l'attività con
                                            <ul class="mt-1">
                                                <li>
                                                    <v-row>
                                                        <v-col cols="6">Partita IVA</v-col>
                                                        <v-col cols="6">{{VATResponse.settings.piva}}</v-col>
                                                    </v-row>
                                                </li>
                                                <li>
                                                    <v-row>
                                                        <v-col cols="6">Denominazione</v-col>
                                                        <v-col cols="6">{{VATResponse.settings.denominazione}}</v-col>
                                                    </v-row>
                                                </li>
                                                <li>
                                                    <v-row>
                                                        <v-col cols="6">Codice ATECO</v-col>
                                                        <v-col cols="6">{{VATResponse.settings.dettaglio.codice_ateco}}</v-col>
                                                    </v-row>
                                                </li> 
                                                <li>
                                                    <v-row>
                                                        <v-col cols="6">Descrizione ATECO</v-col>
                                                        <v-col cols="6">{{VATResponse.settings.dettaglio.descrizione_ateco}}</v-col>
                                                    </v-row>
                                                </li>
                                                <li>
                                                    <v-row>
                                                        <v-col cols="6">Stato Attività</v-col>
                                                        <v-col cols="6">{{VATResponse.settings.dettaglio.cessata?'Cessata':'Attiva'}}</v-col>
                                                    </v-row>
                                                </li>                                                                                                                                                                                                   
                                            </ul>
                                        </v-card-text>
                                        <v-card-text class="text-center text-subtitle-2">Il servizio è riservato alle Aziende in attività e con codice ATECO 561011</v-card-text>
                                        <v-card-text class="text-center">
                                            <v-btn @click="e1=1" color="info">Verifica la Partiva IVA e Riprova</v-btn>
                                        </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="7">
                            <v-card
                                class="mb-2"
                                color="lighten-1"
                            >
                                <v-row>
                                    <v-col cols="12" md="6" class="d-flex justify-center">
                                        <v-img lazy-src="https://ibookrestaurant.com/static/ob-animated-isometric/enter-otp-animate.svg"  src="https://ibookrestaurant.com/static/ob-animated-isometric/enter-otp-animate.svg"></v-img>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-card class="neu-glow elevation-4 mr-2 mt-6">
                                        <v-card-title>
                                            l'OTP inserito è Errato
                                        </v-card-title>
                                        <v-card-text>
                                            l'OTP è stato resettato, pertanto devi reinserire la Partita IVA
                                        </v-card-text>
                                        <v-card-text>
                                            <v-btn @click="e1=1" color="info">Ricomincia dall'inizio</v-btn>

                                        </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card>
                         </v-stepper-content>                         
                    </v-stepper-items>
                </v-stepper>
            </v-form>
        </v-sheet>
      </v-col>
    </v-container>
    <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="snackbar_timeout" >
      <span>{{message}}</span>
    </v-snackbar>    
  </v-sheet>  
</template>
<script>
// Validations
import { required, email,  minLength, maxLength, alphaNum, numeric } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import { mask } from "vue-the-mask";

const defaultForm = {
  OTP:"",
  VATNumber: "",
  agentId:null,
  agreeToPolicy: false,
  allowDuplicateVATNumber:-1,
  identifier: Date.now()
};

export default {
  directives: { mask },
  mixins: [validationMixin],
  validations: {
    userForm: { 
        VATNumber: { required, minLength: minLength(11), maxLength: maxLength(11), async isUnique (value) 
        {
            if (value === '') return true
            if (value.toString().length==11)
            {
                //var json={"VATNumber":value}
                var userToken=localStorage.getItem('userToken')
                var json={"value":value,"action":"check_VATNumber","userToken":userToken,"agentId":this.userForm.agentId,"allowDuplicateVATNumber":this.userForm.allowDuplicateVATNumber}
                //json.action='check_VATNumber'
                console.log(421,json);
                this.vatChecked=1;
                const response =  await this.update_db(json)
                console.log(221,response,response.errorid);
                
                if (response.errorid=='0')
                {
                    this.VATResponse=response;
                    
                    this.accountId=response.all.accountId;
                    this.e1=2;
                    this.message=response.message;
                    this.snackbar_timeout=4000;
                    this.snackbar_color="info"
                    //this.userForm.OTP=response.all.otpVAT;
                    if(response.message)
                    {
                        this.snackbar=true;
                    }
                    return true;                  
                }
                else
                {
                    this.message=response.message;
                    this.snackbar_timeout=8000;
                    this.snackbar_color="error"
                    this.snackbar=true;
                    switch(response.errorid)
                    {
                        case '0001':    //Email already registered
                            this.e1=4;
                        break;
                        case '0002': //Partita IVA Errata
                            this.e1=5;
                        break;
                        case '0003':
                            this.e1=6;//Codice ATECO non Compatibile
                        break;

                    }
                    return false; 
                }
                //return Boolean(await response.errorid != '0')
            }
            else
            {
                //this.e1=2;
                return true;
            }
        } 
        },
        OTP: { required, minLength: minLength(11), maxLength: maxLength(11), async isUnique (value) 
        {
            if (value === '') return true
            if (value&&value.length==11)
            {
                //var json={"VATNumber":value}
                var userToken=localStorage.getItem('userToken')
                var json={"value":value,"action":"check_OTP","userToken":userToken}
                //json.action='check_VATNumber'
                const response =  await this.update_db(json)
                console.log(418,response,response.errorid);
                this.VATResponse2=response;
                if (response.errorid=='0')
                {
                    this.e1=3;
                    this.message=response.message;
                    this.snackbar_timeout=2000;
                    this.snackbar_color="info" 
                    this.snackbar=true;
                    this.setupToken=response.settings.setUpToken;
                    return true;                  
                }
                else
                {
                    this.message=response.message;
                    this.snackbar_timeout=8000;
                    this.snackbar_color="error"
                    this.snackbar=true;
                    switch(response.errorid)
                    {
                        case '0001':    //OTP Errato
                            this.e1=7;
                        break;

                    }
                    return false; 
                }
                //return Boolean(await response.errorid != '0')
            }
            else
            {
                //this.e1=2;
                return true;
            }
        } 
        },        

      password: { required, minLength: minLength(6) },
      agreeToPolicy: { accepted: val => val === true }
    }  },
  validationMessages: {
    userForm: {
      VATNumber: {
        required: 'Inserisci la Partita IVA',
        minLength: 'La Partita IVA è composta da 11 Cifre',
        maxLength: 'La Partita IVA è composta da 11 Cifre',
        isUnique: 'Partita IVA già Registrata'
      },
      OTP: {
        required: 'Inserire l\'OTP',
        minLength: 'L\'OTP è composta da 9 Cifre',
        maxLength: 'L\'OTP è composta da 9 Cifre',
        isUnique: 'OTP già utilizzata'
      },      
      OTP1: {
        required: 'Iserisci la OTP'
      },      
    }             
  },
  data()
  {
    return {
      page:'Auth',
      userForm: Object.assign({}, defaultForm),
      vatChecked:false,
      showPwd: false,
      snackbar: false,
      snackbar_color:null,
      snackbar_timeout:2000,
      dialog:false,
      dialog_tos:false,
      message:'',
      code: null,
      iframeheight:800,
      loader:false,
      username_duplicated:false,
      email_duplicated:false,
      openapi_loading:false,
      email_error:null,
      locale:null,
      VATResponse:null,
      VATResponse2:null,
      e1:1,
      setupToken:null,
      allowDuplicateVATNumber:-1,
      VATRules:
      [
        v => !!v || "Inserire la Partita IVA",
        v => /^\d{7}[0-1]\d{3}$/.test(v) || "La partita IVA è di 11 Cifre"
      ],
      OTPRules:
      [
        v => !!v || "Inserire l'OTP",
        v => /^\d{3}-\d{3}-\d{3}$/.test(v) || "L'OTP è di 9 Cifre"
      ]
    };
  },
  created(){
    this.locale=window.navigator.userLanguage||window.navigator.language;
    console.log(387,this.locale);
    document.title = 'iBookrestaurant | signup';
    this.$store.dispatch("setLocale",this.locale.substring(0,2));
    this.setIframeHeight();
    localStorage.removeItem('user')
    localStorage.removeItem('settings')
    sessionStorage.removeItem('settings')
    sessionStorage.removeItem('jwt')
  },
  methods: {
        goTo()
        {
            this.$router.push('/auth/login/?setupToken='+this.setupToken).catch(() => {});
        },
        async submitOTP() {
        this.loader=true;
        try{
          const res = await this.$http.post('/auth/checkotp.php', {"code":this.code})    
          if (res.data.errorid=='0'){
            sessionStorage.setItem('jwt', res.data.jwt);
            sessionStorage.setItem('hash', res.data.hash);
            this.$emit("next", { email: this.email });
            this.message=res.data.message;
          }
          else
          {
            this.message=res.data.message;
          }
      } catch(e)
      {
        /*let user2='{"errorid":"0005","message":"Email non censita","level":"6","active":"1","company":"xLogistics","email":"mail@jslab.it","landingpage":"dashboard","avatar":"/static/avatar/nir.jpg","subscriptionlevel":"0","subscriptionexpiry":"2021-01-31 00:00:00.000","credits":".0000","name":"Nir Erlich","currency":"ils","locale":"he"}';
        let user3=JSON.parse(user2);
        this.message=user3.message;*/
      }
      this.loader=false;
    },

    async update_db(payload){
      try{
          //const res = await this.$http.post('/settings/settings_write.php', {"fieldname":fieldname,"fieldvalue":fieldvalue});
          payload.locale=this.locale.substring(0,2);
          payload.agent='1';
          let json=JSON.stringify(payload);
          console.log(2100,json);
          const res = await this.$http.post('/auth/signup.php', json);
          console.log(362,'signup',res);
          this.formReadOnly=false;
          if (res.data.errorid=='0')
          {
            if(res.data.jwt)
            {
              sessionStorage.setItem('jwt', res.data.jwt);
              //sessionStorage.setItem('settings', res.data.settings);
            }
            //this.snackbar_color='success';
            console.log(792,res.data);
          }
          else
          {
            this.snackbar_color='error'
            //this.$router.push('/auth/login').catch(() => {});
          }
          //this.message=res.data.message;
          //this.snackbar=true;
          return res.data;
      } catch(e)
      {
        console.log(e);
      }
    },  
    setIframeHeight(){
      this.iframeheight=screen.height-200
    },
    async submit_old()
    {
      //this.loader=true
      console.log(427)
      if (this.loader==true)
      {
        this.message='Under Development';
        this.dialog=true;
        this.loader=false;
      }
      else
      {
        this.loader=true;
        try
        {
          console.log(439);
          this.userForm.action='checkVAT';
          this.userForm.locale=this.locale.substring(0,2);
          const res = await this.$http.post('/auth/signup.php', this.userForm)
          sessionStorage.setItem('jwt', res.data.jwt);
          //sessionStorage.setItem('settings', JSON.stringify(res.data.settings));
          //localStorage.setItem('user', JSON.stringify(res.data.user));
          console.log(450,res);
          this.e1=2;
          if (res.data.settings)
          {
            
            //this.snackbar = true;
            console.log(765,res.data);
            console.log(391,JSON.stringify(res.data.settings));

            /*
            if(res.data.user.hostname!=='zbooking')
            {
              this.$router.push('../'+landingPage);
            }
            else
            {
            window.location.href = site;  
            }*/
          }
          else
          {
            if (res.data.errorid!="0"){
              this.message=res.data.message;
              this.dialog=true;
            }
          }
        }
        catch(e)
        {
          this.message='Server Error: Try Later';
          this.dialog=true;
        }
      }
      this.loader = false;
    },
    resetForm() {
      this.userForm = Object.assign({}, this.defaultForm);
      this.$refs.userForm.reset();
    },
  }
};
</script>